import { render, staticRenderFns } from "./ProductFeedbackHeader.vue?vue&type=template&id=40b3d955&"
import script from "./ProductFeedbackHeader.vue?vue&type=script&lang=js&"
export * from "./ProductFeedbackHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports